import React from 'react';
import { fetchEventFaq, fetchSpace } from '../app-main/actions/space';
import { fetchListingsBySpace } from '../app-main/actions/listings';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Spinner } from '../shared-components/decorators/spinner';
import PropTypes from 'prop-types';

const FaqContainerHOC = (WrappedComponent) => {
  class faq extends React.Component {
    constructor (props) {
      super(props);

      this.state = {
        hasFetched: false
      };
    }

    async componentDidMount () {
      const { dispatch, accessToken, params, location } = this.props;
      const path = get(location, 'pathname', '');
      const isEventPage = path.includes('event');
      try {
        await dispatch(fetchSpace(params.spaceId, accessToken));
        await dispatch(fetchListingsBySpace(params.spaceId, accessToken));
        if (isEventPage) {
          await dispatch(fetchEventFaq(params.spaceId, accessToken));
        }
        this.setState({ hasFetched: true });
      } catch (e) {
        this.setState({ hasFetched: true });
      }
    }

    render () {
      const { params, listings, space, accessToken } = this.props;
      const page = get(params, 'page');

      if (!this.state.hasFetched) {
        return (
          <div className="spinner-container">
            <Spinner additionalStyle="gray" />
          </div>
        );
      }

      return (
        <div className="FaqQuestionsContainer ps-container-lg-margin ps-container-fixed">
          <WrappedComponent
            accessToken={accessToken}
            page={page}
            space={space}
            listings={listings}
            submit
            eventFaq={this.props.eventFaq}
          />
        </div>
      );
    }
  }

  function mapStateToProps (state) {
    const {
      auth,
      profile,
      space,
      form,
      listings
    } = state;

    const {
      isFetching
    } = profile || {
      isFetching: true
    };

    return {
      auth,
      profile,
      space,
      isFetching,
      form,
      listings
    };
  }

  faq.propTypes = {
    listings: PropTypes.array,
    accessToken: PropTypes.string,
    page: PropTypes.string,
    space: PropTypes.object,
    dispatch: PropTypes.func,
    params: PropTypes.object,
    eventFaq: PropTypes.object
  };

  return connect(mapStateToProps)(injectIntl(faq));
};

export default FaqContainerHOC;
